var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-suggestion" },
    [
      _vm._t("label", [
        _vm.label || _vm.$t("suggestable_models." + this.model)
          ? _c(
              "div",
              {
                class:
                  "label-div text-sm " + (_vm.focused ? "text-primary" : "")
              },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.label || _vm.$t("suggestable_models." + this.model)
                    )
                  )
                ])
              ]
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "flex flex-row gap-1 w-full" }, [
        _c(
          "div",
          { staticClass: "min-h-full w-full relative" },
          [
            _c(
              "vs-select",
              {
                ref: "select",
                staticClass: "w-full",
                attrs: {
                  autocomplete: "",
                  placeholder: _vm.translatedPlaceholderText,
                  danger: _vm.selectedModel === undefined,
                  "danger-text": "Seleção inválida",
                  noData: _vm.noData,
                  disabled: _vm.disabled
                },
                on: {
                  "input-change": _vm.searchSuggestions,
                  input: _vm.selectModel,
                  focus: _vm.onFocus,
                  blur: function($event) {
                    _vm.focused = false
                  }
                },
                model: {
                  value: _vm.selectedModelId,
                  callback: function($$v) {
                    _vm.selectedModelId = $$v
                  },
                  expression: "selectedModelId"
                }
              },
              _vm._l(_vm.suggestedModels, function(model) {
                return _c("vs-select-item", {
                  key: model.id,
                  attrs: { value: model.id, text: _vm.itemTextFormat(model) }
                })
              }),
              1
            ),
            _c("div", {
              staticClass:
                "loadingContainer absolute inset-0 pointer-events-none p-3 pr-6 flex items-center justify-end"
            })
          ],
          1
        ),
        _vm.selectedModelId && _vm.appendClearOption
          ? _c("div", { staticClass: "flex-shrink-0 flex items-center" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top",
                      value: {
                        content: "Limpar seleção",
                        delay: { show: 100, hide: 100 }
                      },
                      expression:
                        "{content: 'Limpar seleção',delay: { show: 100, hide: 100 }}",
                      modifiers: { top: true }
                    }
                  ],
                  staticClass:
                    "clear-button-side p-2 rounded border border-gray-300 hover:border-red-400 hover:bg-red-50 transition-all",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.clearSelection($event)
                    }
                  }
                },
                [
                  _c("b-icon-x", {
                    staticClass: "text-gray-500 hover:text-red-500"
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }